/**
 * Login Empresa (Carlos jun 28, 2026)
 * POST /empresas/login → guarda empresa_token → redirige a /empresas/docs si no aprobada,
 *                                                o a /empresas/panel si ya aprobada.
 */
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import empresaApi from '../utils/empresaApi';

const EmpresaLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await empresaApi.post('/empresas/login', { email: email.trim().toLowerCase(), password });
      localStorage.setItem('empresa_token', res.data.access_token);
      const status = res.data.status;
      if (status === 'approved') {
        navigate('/empresas/panel');
      } else {
        navigate('/empresas/docs');
      }
    } catch (err) {
      setError(err?.response?.data?.detail || 'Email o contraseña incorrectos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-emerald-50 flex items-center justify-center py-10 px-4">
      <div className="max-w-md w-full">
        <Link to="/" className="text-sm text-emerald-700 hover:underline">← Volver al inicio</Link>
        <div className="mt-4 bg-white rounded-2xl shadow-lg border border-slate-200 p-8">
          <h1 className="text-2xl font-black text-slate-900 text-center mb-2">🏢 Acceso Empresas</h1>
          <p className="text-xs text-slate-600 text-center mb-6">Plataforma de envíos para empresas</p>

          <form onSubmit={submit} className="space-y-3" data-testid="emp-login-form">
            <label className="block">
              <span className="text-xs font-semibold text-slate-700 mb-1 block">Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="emp-login-email"
                className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-400 outline-none"
              />
            </label>
            <label className="block">
              <span className="text-xs font-semibold text-slate-700 mb-1 block">Contraseña</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="emp-login-password"
                className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-400 outline-none"
              />
            </label>
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-800 text-sm rounded p-3" data-testid="emp-login-error">{error}</div>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="emp-login-submit"
              className="w-full bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white font-semibold py-3 rounded-lg"
            >
              {loading ? 'Ingresando…' : 'Ingresar'}
            </button>
          </form>

          <p className="text-center text-xs text-slate-600 mt-4">
            ¿Aún no tienes cuenta?{' '}
            <Link to="/empresas/registro" className="text-emerald-700 hover:underline font-medium">
              Regístrate aquí
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmpresaLogin;
